export default {
    en: {
      "placeholder.label.SelectDate": "Select Date",
    },
  
    fr: {
      "placeholder.label.SelectDate": "Sélectionner une date",
    },
  
    es: {
      "placeholder.label.SelectDate": "Seleccionar fecha",
    },
  
    pt: {
      "placeholder.label.SelectDate": "Selecionar data",
    },
  
    zh_CN: {
      "placeholder.label.SelectDate": "选择日期",
    },
  
    hi: {
      "placeholder.label.SelectDate": "तारीख़ चुनें",
    },
  
    ka: {
      "placeholder.label.SelectDate": "თარიღის არჩევა",
    },
  
    lo: {
      "placeholder.label.SelectDate": "ເລືອກວັນທີ",
    },
  
    my_MM: {
      "placeholder.label.SelectDate": "ရက်စွဲရွေးပါ",
    },
  
    my: {
      "placeholder.label.SelectDate": "ရက်စွဲရွေးပါ",
    },
  
    vi: {
      "placeholder.label.SelectDate": "Chọn ngày",
    },
  };
  